import React, { useState } from 'react';

import { Box, FormControlLabel, RadioGroup } from '@material-ui/core';

import { NASSRadio } from 'src/components';
import { DATE_PICKER_DISPLAY_FORMAT } from 'src/constants/common';
import { NATIONALITY } from 'src/constants/users.constants';
import { IUser } from 'src/services/users';

import { Title } from '../components/additional-information.styled';
import {
  Label,
  FormTextField,
  FormMenuItem,
  GeneralInformationDatePicker,
  ActionButton,
} from '../components/general-information.styled';
import VerifyStatus from '../shared/verify.message';

interface Props {
  onOpenEditAdditionalInformation: () => void;
  profile: IUser | null;
}

const AdditionalInformationForm = ({ onOpenEditAdditionalInformation, profile }: Props) => {
  const [isHaveChildren, setHaveChildren] = useState<boolean>(
    profile?.child && profile?.child.length > 0 ? true : false,
  );

  React.useEffect(() => {
    setHaveChildren(profile?.child && profile?.child.length > 0 ? true : false);
  }, [profile]);

  return (
    <Box px={3} pb={3}>
      <Title>Your children info</Title>
      <Box mt={3} mb={1.8}>
        <Label>Do You Have Children?</Label>
        <RadioGroup
          value={isHaveChildren && profile?.child && profile?.child?.length > 0 ? 'yes' : 'no'}
          onChange={(e, v) => {
            setHaveChildren(v === 'no' ? false : true);
          }}
          row
        >
          <FormControlLabel value="yes" control={<NASSRadio disabled />} label="Yes" disabled />
          <Box width={160} />
          <FormControlLabel value="no" control={<NASSRadio disabled />} label="No" disabled />
        </RadioGroup>
      </Box>
      {isHaveChildren && profile?.child && profile?.child?.length > 0 && (
        <Box mb={0.5} display="flex" style={{ gap: 16 }}>
          <Box flex="1">
            <Label>Child’s Surname</Label>
          </Box>
          <Box flex="1">
            <Label>Child’s Given Name</Label>
          </Box>
          <Box flex="1">
            <Label>Child’s Date Of Birth</Label>
          </Box>
          <Box flex="1">
            <Label>Nationality</Label>
          </Box>
          <Box flex="1.1" />
        </Box>
      )}

      {isHaveChildren &&
        profile?.child &&
        profile?.child?.length > 0 &&
        profile?.child.map((item) => (
          <Box mb={3} display="flex" style={{ gap: 16 }}>
            <Box flex="1">
              <FormTextField variant="outlined" fullWidth disabled value={item.surname} />
            </Box>
            <Box flex="1">
              <FormTextField variant="outlined" fullWidth disabled value={item.givenName} />
            </Box>
            <Box flex="1">
              <GeneralInformationDatePicker
                disabled
                fullWidth
                autoOk
                variant="inline"
                inputVariant="outlined"
                format={DATE_PICKER_DISPLAY_FORMAT}
                value={item.dateOfBirth}
                InputAdornmentProps={{ position: 'end' }}
                onChange={(date) => {}}
              />
            </Box>
            <Box flex="1">
              <FormTextField
                ellipsis
                variant="outlined"
                name="gender"
                fullWidth
                disabled
                size="small"
                value={item.nationality}
                onChange={() => {}}
                select={true}
                SelectProps={{
                  MenuProps: {
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                  },
                }}
              >
                {NATIONALITY.map(({ value, label }, idx) => (
                  <FormMenuItem key={idx} value={value}>
                    {label}
                  </FormMenuItem>
                ))}
              </FormTextField>
            </Box>
            <Box flex="1.1">
              {item?.verificationStatus || false ? (
                <VerifyStatus variants="verify" onRemove={() => {}} />
              ) : (
                <VerifyStatus variants="un-verify" onRemove={() => {}} />
              )}
            </Box>
          </Box>
        ))}

      <Box display="flex" justifyContent="center">
        <ActionButton variants="yellow" onClick={onOpenEditAdditionalInformation}>
          {isHaveChildren && profile?.child && profile?.child?.length > 0 ? 'Edit' : 'Add'}
        </ActionButton>
      </Box>
    </Box>
  );
};

export default AdditionalInformationForm;
